import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useColors, ThemeColors } from '../hooks/useColors';
import { useVendors } from '../hooks/useVendors';
import { VendorList } from '../components/vendors/VendorList';
import { LoadingState } from '../components/ui/LoadingState';

export default function VendorsScreen() {
  const colors = useColors();
  const styles = createStyles(colors);
  const { data: vendors, isLoading } = useVendors();

  if (isLoading) return <LoadingState />;

  return (
    <View style={styles.container}>
      <VendorList vendors={vendors || []} />
    </View>
  );
}

const createStyles = (colors: ThemeColors) => StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
}); 